// extracted by mini-css-extract-plugin
export var container = "testimonial-module--container--2J0V9";
export var bg = "testimonial-module--bg--m9ABI";
export var inner = "testimonial-module--inner--ywQfY";
export var card = "testimonial-module--card--VH2Zs";
export var cardStars = "testimonial-module--cardStars--WwOyl";
export var info = "testimonial-module--info--EDqnk";